import { Check } from "lucide-react";
import { LINKS } from "./links";

const FEATURES = [
  "Build your sizing profile",
  "Add shoes and sizes you already know fit",
  "Get size recommendations",
  "Keep your recommendation history",
  "Share whether a recommendation worked",
  "Build useful fit knowledge across brands",
];

const ForShoppers = () => (
  <section id="shoppers" data-testid="shoppers-section" className="section-pad border-t border-[var(--line)]">
    <div className="container-x grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
      <div>
        <p className="eyebrow mb-6">For Shoppers</p>
        <h2 className="font-display text-4xl leading-[1.1] tracking-tight sm:text-5xl">
          Your fit history, in one place.
        </h2>
        <p className="mt-6 max-w-md text-base leading-relaxed text-[var(--ink-soft)]">
          Intuitive Shoes gives you a personal space to build useful fit
          knowledge across the brands you wear.
        </p>
        <ul data-testid="shoppers-feature-list" className="mt-9 space-y-4">
          {FEATURES.map((feature) => (
            <li key={feature} className="flex items-start gap-3 text-base">
              <Check size={18} className="mt-0.5 shrink-0 text-[var(--rust)]" aria-hidden="true" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        <a
          href={LINKS.APP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="shoppers-explore-btn"
          className="btn-primary mt-10"
        >
          Explore Intuitive Shoes
        </a>
      </div>

      <div className="flex items-center">
        <img
          src="/images/intuitive-shoes-flatlay.jpg"
          alt="Two open shoe boxes with white sneakers and a phone showing the Intuitive Shoes app"
          data-testid="shoppers-app-screenshot"
          className="h-auto w-full object-cover"
          loading="lazy"
        />
      </div>
    </div>
  </section>
);

export default ForShoppers;
